export default {
  required: 'Field %1 is required',
  text: 'Field %1 can\'t contain quotes!',
  email: 'Please enter correct email. E.g. "johndoe@domain.com"',
  date: 'Please enter correct date in yyyy/mm/dd format. E.g. "2018-03-23". The year should be greater than 1900 and less or equal to 2015',
  password_incorrect: 'Password is incorrect',
  repassword: 'Passwords must be equal',
  phone: 'Phone no. is invalid',
  number: 'Field %1 should contain only digits',
};



// WEBPACK FOOTER //
// ./scripts/blocks/form/validator/utils/errors.js